module.exports = __webpack_public_path__ + "static/media/search-full-btn.43145070.svg";